import { useTranslation } from 'react-i18next';
import { EventInput } from '@amzn/red-velvet-api';

export interface EventStepProps {
  currentFields: EventInput;
  updateFieldHandler: (fields: EventInput) => void;
  errors?: Record<string, string>;
  isReadOnly?: boolean;
  metricPrefix: string;
  /** Available during edit-event flow. Forwarded to AI audit logging. */
  eventId?: string;
}

export function OptionalLabel({ children }: { children: string }) {
  const namespaces = ['events', 'translation'];
  const { t } = useTranslation(namespaces);
  return (
    <span>
      {children} - <i>{t('misc.optional')}</i>
    </span>
  );
}
